import { Modal } from 'antd';
import axios, { AxiosRequestConfig } from 'axios';
import { AuthEnum } from '../enum/auth.enum';
import { Auth } from '../models/auth.model';
import { useNotificationService } from '../services/notification.service';
import { clear, getObject } from '../util/store';
import { useGlobalContext } from '../context/GlobalContext';
import { ITipoUnidadeCleanDTO, IUnidadeCleanDTO, IUnidadeFullDTO } from '../models/happy-code-api.model';

const http = axios.create({
	baseURL: process.env.REACT_APP_HAPPYCODE_PUBLIC_BASE_URL_API,
});

const token = () => {
	const auth = getObject(AuthEnum.TOKEN_KEY) as Auth;
	return auth?.access_token;
};

const tipoUnidadeIdFranquia = () => {
	const tipoUnidade = getObject("@HappyCode/tipounidade") as ITipoUnidadeCleanDTO ;
	return tipoUnidade?.codigo;
}

const tipoUnidadeIdSede = () => {
	const unidade = getObject("@HappyCode/unidade") as IUnidadeFullDTO ;
	return unidade?.tipoUnidade?.codigo;
}


const defaultErrorMessage = 'Ação não concluída. Tente novamente ou contate o suporte! [2]';

http.interceptors.request.use(
	(request: AxiosRequestConfig) => {

		if (!request.headers['Authorization']) {
			request.headers['Authorization'] = `Bearer ${token()}`;
		}
		if (!request.headers['Content-Type']) {
			request.headers['Content-Type'] = 'application/json';
		}
		if (!request.headers['Accept']) {
			request.headers['Accept'] = 'application/json';
		}

		if (!request.headers['x-tipo-unidade-ds'] && tipoUnidadeIdFranquia() != null){
			request.headers['x-tipo-unidade-ds'] = tipoUnidadeIdFranquia();
		}

		if (!request.headers['x-tipo-unidade-ds'] && tipoUnidadeIdSede() != null){
			request.headers['x-tipo-unidade-ds'] = tipoUnidadeIdSede();
		}
		
		return request;
	},
	(error) => Promise.reject(error)
);

http.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.config.headers['noMessage']) return Promise.reject(error);
		if (error && error.response) {
			const { status } = error.response;

			const notification = useNotificationService();
			switch (status) {
				case 401: {
					if (getObject('@HappyCode/login')) {
						notification({
							description: 'Seu token expirou. Faça o login novamente.',
							type: 'warning',
							message: 'Token expirado',
						});
					} else {
						notification({
							description: 'Usuário ou senha incorreto',
							type: 'warning',
							message: 'Falha ao Logar',
						});
					}
					setTimeout(() => {
						const path = window.location.pathname;

						if (path !== '/login') window.location.href = '/login';

						clear();
					}, 2500);

					break;
				}
				case 404:
					notification({
						description: error.response.data?.message,
						type: 'warning',
						message: 'Aviso',
					});
					break;
				case 400:
					if (error.response.data.error_description === 'Bad credentials') {
						notification({
							description: 'Usuário ou senha incorreto',
							type: 'warning',
							message: 'Falha ao Logar',
						});
						break;
					}

					if (error.config.url == 'cobranca/pagarme')
						Modal.error({
							content: error.response.data?.message || defaultErrorMessage,
							title: 'Problema no pagamento',
						});
					else {
						if (error.response.data?.message === 'Problema nos parâmetros informados')
							notification({
								description: error.response.data.details[0] || defaultErrorMessage,
								type: 'error',
								message: 'Atenção!',
							});
						else
							notification({
								description: error.response.data?.message || defaultErrorMessage,
								type: 'error',
								message: 'Atenção!',
							});
					}

					break;

				default:
					if (error.config.url == 'cobranca/pagarme')
						Modal.error({
							content: error.response.data?.message || defaultErrorMessage,
							title: 'Problema no pagamento',
						});
					else
						notification({
							description: error.response.data?.message || defaultErrorMessage,
							type: 'error',
							message: 'Atenção!',
						});

					break;
			}
		}
		return Promise.reject(error);
	}
);

export default http;
